import { DataObjectEditorStore } from '../Editor/DataObjectEditorStore';
import { BaseComponent } from '../../../../../../@Framework/Component/BaseComponent';
import { DataObjectBespokeEditorStore } from './DataObjectBespokeEditorStore';

export abstract class DataObjectBespokeEditor<T extends DataObjectBespokeEditorStore = DataObjectBespokeEditorStore> extends BaseComponent<DataObjectEditorStore<T>>
{

}
